import React from 'react';
import useLanguage from '../../../Services/Language/useLanguageHook';
import trackingService, { TrackingEvent } from '../../../Services/Tracking/TrackingService';
import CheckboxInput from '../../Form/Inputs/CheckboxInput';
import ActionModal from '../ActionModal/ActionModal';
import styles from './ConfirmModal.module.scss';

interface IConfirmModalProps {
    header: string;
    showModal: boolean;
    message: string;
    handleConfirm: () => void;
    handleCancel: () => void;
    checkboxMessage?: string;
    handleCheckbox?: (value: boolean) => void;
    track: TrackingEvent;
}
const ConfirmModal: React.FC<IConfirmModalProps> = (props: IConfirmModalProps) => {
    const [translations] = useLanguage();

    const handleConfirm = () => {
        props.handleConfirm();

        trackingService.track({ eventCategory: props.track.eventCategory, eventAction: `${props.track.eventAction}Confirmed` });
    };

    const handleCancel = () => {
        props.handleCancel();

        trackingService.track({ eventCategory: props.track.eventCategory, eventAction: `${props.track.eventAction}Cancelled` });
    };

    return (
        <ActionModal
            header={props.header}
            showModal={props.showModal}
            actionButtonName={translations.actions.confirm}
            handleAction={handleConfirm}
            handleCancel={handleCancel}
            track={props.track}
        >
            <div>
                <div className={styles.alert_modal_message_container}>{props.message}</div>
                {props.handleCheckbox && (
                    <div className={styles.alert_modal_checkbox_container}>
                        <h2>{props.checkboxMessage}</h2>
                        <CheckboxInput isChecked={false} handleIsChecked={props.handleCheckbox} track={props.track} />
                    </div>
                )}
            </div>
        </ActionModal>
    );
};

export default ConfirmModal;
